<template>
  <div class="flex justify-center">
    <div class="py-10 lg:w-8/12 md:w-10/12 w-full px-4 md:px-6 lg:px-0">
      <d-message v-if="error" type="error" class="w-full mb-3">
        {{ error }}
      </d-message>

      <h1 class="font-bold">
        Promo Code Access
      </h1>

      <form ref="form" class="mt-16" @submit.prevent="submitForm">
        <div class="md:flex -mx-5">
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="First Name*">
              <d-input v-model="form.firstName" name="firstName" required />
            </d-field>
          </div>
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Last Name*">
              <d-input v-model="form.lastName" name="lastName" required />
            </d-field>
          </div>
        </div>
        
        <div class="md:flex -mx-5">
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Email Address*">
              <d-input v-model="form.email" name="email" required type="email" />
            </d-field>
          </div>
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Mobile Phone #*">
              <d-input v-model="form.phoneNumber" name="phoneNumber" required />
            </d-field>
          </div>
        </div>
        
        <div class="md:flex -mx-5">
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="ZIP Code*">
              <d-input v-model="form.zipCode" name="zipCode" required />
            </d-field>
          </div>
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Promo Code*">
              <d-input v-model="form.promoCode" name="promoCode" required />
            </d-field>
          </div>
        </div>
        
        <div class="md:flex justify-end items-center mt-8 hidden">
          <d-btn type="submit" :loading="submitting">
            Login
          </d-btn>
        </div>
        <div class="md:hidden pt-5">
          <d-btn type="submit" :loading="submitting" block>
            Login
          </d-btn>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    parent: true,

    data() {
      return {
        submitting: false,
        error: '',
        form: {
          firstName: '',
          lastName: '',
          email: '',
          promoCode: '',
          zipCode: '',
          phoneNumber: '',
        },
      };
    },

    mounted() {
      const urlParams = new URLSearchParams(window.location.search);
      this.form.promoCode = urlParams.get('promo');
    },

    methods: {
      async submitForm() {
        this.submitting = true;
        this.error = '';
        try {
          await axios.post('/api/login/promo', this.form);
          window.location = '/';
        } catch (error) {
          this.error = error.response.data.errors[0];
        } finally {
          this.submitting = false;
        }
      },
    },
  };
</script>